<script setup lang="ts">
export interface Props {
  width?: string;
  title: string;
  message?: string;
  date?: string;
  divider?: boolean;
  effect?: boolean;
  unread?: boolean;
}

withDefaults(defineProps<Props>(), {
  date: '',
  message: '',
  effect: true,
  divider: true,
  width: '20rem',
  unread: false,
});
</script>

<template>
  <div class="notification-card" :class="{ 'bottom-divider': divider, 'card-effect': effect, 'card-unread': !unread }">
    <div class="notification-card-body">
      <div class="notification-card-title" v-if="title">{{ title }}</div>
      <div class="notification-card-items">
        <div class="notification-card-item">{{ message }}</div>
      </div>
      <div class="notification-card-date" v-if="date">{{ date }}</div>
    </div>
    <div class="notification-card-unread notification-card-dot" v-if="unread"></div>
  </div>
</template>

<style scoped lang="scss">
.notification-card {
  padding: 18px;
  padding-right: 26px;
  text-align: left;
  position: relative;
  background-color: var(--shade-1);

  &-body {
    outline: 0px solid red;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &-title {
    font-size: 18px;
    font-weight: bold;
  }

  &-items {
    font-size: 14px;
    padding-right: 10px;
  }

  &-date {
    color: var(--shade-4);
    font-size: 14px;
  }

  &-unread {
    position: absolute;
    bottom: 42%;
    right: 18px;
    color: var(--shade-4);
    font-size: 12px;
  }

  &-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--primary-text-color);
  }
}

.card-effect {
  cursor: pointer;
  &:hover {
    background-color: var(--shade-2);
  }
}

.card-unread {
  background-color: var(--shade-0);
}

.bottom-divider {
  border-bottom: 1px solid var(--shade-3);
}
</style>
